import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

const PHOTO_SIZE = 40;

export const styles = StyleSheet.create((colors) => ({
  container: {
    gap: theme.spacing[5],
  },
  divider: {
    height: 1,
    backgroundColor: colors.borderSecondaryAlpha,
  },
  stylistRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[4],
  },
  // Radius xs (8, hard-coded in Figma) — not `theme.borderRadius.s` used by the
  // offer card's own glyph tile (design-refs Element table).
  photo: {
    width: PHOTO_SIZE,
    height: PHOTO_SIZE,
    borderRadius: theme.borderRadius.xs,
  },
  photoTile: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.backgroundL1,
    overflow: 'hidden',
  },
  group: {
    gap: theme.spacing[1],
  },
  groupGapDesktop: {
    gap: theme.spacing[2],
  },
  valueRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  services: {
    gap: theme.spacing[4],
  },
}));
